import ToolBox from '../ToolBox';
import Template from "ui/Template";
import {i18n} from "ui/i18n";
import {EVENT_SET_BRUSH} from "ui/canvas/Canvas";
import brushView from './brush.handlebars';

/**
 * Brush toolbox
 */
class Brush extends ToolBox {
	/**
	 * Class constructor
	 *
	 * @param {Object} [options]
	 */
	constructor(options = {}) {
		super(Object.assign({
			title: i18n('title.brush')
		}, options));

		this.setBodyElement(
			new Template(brushView)
				.createElement({})
		);

		this._els = {
			size: this.body.querySelector('span'),
			circle: this.body.querySelector('svg circle'),
		};

		this.scene.canvas.events.addListener(EVENT_SET_BRUSH, this.updateSize.bind(this));
		this.updateSize();
	}

	/**
	 * Updates brush avatar
	 *
	 * @returns {void}
	 */
	updateSize() {
		let size = this.scene.canvas.getBrushSize();
		this._els.circle.setAttribute('r', String(Math.max(1, size / 2)));
		this._els.size.innerText = size + 'px';
	}
}

export default Brush;
